module.exports = __webpack_public_path__ + "jenkins_binding.png";